import produce from 'immer';
import { create } from 'zustand';
import { Transaction, VersionedTransaction } from '@solana/web3.js';

type TxErrorType = 'swap' | string;

export type TxError = {
	error: string;
	ts: number;
	type: TxErrorType;
};

export interface TxDataStore {
	set: (x: (s: TxDataStore) => void) => void;
	get: (x: any) => TxDataStore;
	preppedPerpTradeformTxs: null | {
		placeAndTakeTx: Transaction | VersionedTransaction;
		cancelExistingOrdersTx: Transaction | VersionedTransaction;
		settlePnlTx: Transaction | VersionedTransaction;
	};
	txErrors: TxError[];
	addNewTxError: (error: TxError) => void;
}

const useTxDataStore = create<TxDataStore>((set, get) => ({
	set: (fn) => set(produce(fn)),
	get: () => get(),
	preppedPerpTradeformTxs: null,
	txErrors: [],
	addNewTxError: (error: TxError) => {
		set((state) => ({
			txErrors: [...state.txErrors.slice(-9), error],
		}));
	},
}));

export default useTxDataStore;
